import { render } from "./basket.vue?vue&type=template&id=6558af52&scoped=true&ts=true"
import script from "./basket.vue?vue&type=script&lang=ts"
export * from "./basket.vue?vue&type=script&lang=ts"

import "./basket.vue?vue&type=style&index=0&id=6558af52&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6558af52"]])

export default __exports__